/*
  Project: City Of Gretna
  Author: Xfive
 */

require('addtocalendar/addtocalendar.js');
require('lazysizes');
require('./documents-search');
require('./city-directory');

import fitvids from 'fitvids';
import slider from './slider';
import navigation from './navigation';
import datepicker from './datepicker';
import clearFormFields from './clear-form-fields';
import scrollToResults from './events';

document.addEventListener("DOMContentLoaded", function () {
  new slider();
  new navigation();
  new datepicker();
  new clearFormFields();

  fitvids();

  scrollToResults();
});
